<!-- 日期范围选择 -->
<template>
<div>
	<a-range-picker style="width:220px;" 
	@change="onChangeDate" 
	:allowClear="false"
	:locale="locale" 
	:value="[this.moment(startTime, dateFormat),this.moment(endTime, dateFormat)]" />
</div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
export default {
	name: 'rangePicker',
	props: ['page_type'],
	data(){
		this.dateFormat = 'YYYY-MM-DD'
		return {
			locale,
			moment,
			startTime: '2023-01-01', // 投放日期-开始时间
			endTime: '2023-01-01', // 投放日期-结束时间
		}
	},
	mounted(){
		this.endTime = this.$getThisDay()
		this.startTime = this.$getThisDay() // 默认只获取当天
		
		// 给父组件传递请求用的日期
		let arr = []
		arr.push(this.startTime)
		arr.push(this.endTime)
		this.onChangeDate('',arr)
	},
	methods: {
		// 日期选择
		onChangeDate(date, dateString) {
			// console.log("date", date);
			// console.log("dateString", dateString);
			this.startTime = dateString[0]
			this.endTime = dateString[1]
			this.$emit('change-date', dateString)
		},
	}
}
</script>

<style>
</style>